import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { Disposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { IOpenerService } from 'monaco-editor/esm/vs/platform/opener/common/opener.js';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService';

let ExternalUriResolverContribution = class ExternalUriResolverContribution extends Disposable {
    constructor(_openerService, _workbenchEnvironmentService) {
        super();
        if (_workbenchEnvironmentService.options && _workbenchEnvironmentService.options.resolveExternalUri) {
            this._register(_openerService.registerExternalUriResolver({
                resolveExternalUri: async (resource) => {
                    return {
                        resolved: await _workbenchEnvironmentService.options.resolveExternalUri(resource),
                        dispose: () => {
                        }
                    };
                }
            }));
        }
    }
};
ExternalUriResolverContribution = ( __decorate([
    ( __param(0, IOpenerService)),
    ( __param(1, IBrowserWorkbenchEnvironmentService))
], ExternalUriResolverContribution));

export { ExternalUriResolverContribution };
